import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'replace',
})
export class ReplacePipe implements PipeTransform {
    transform(value: string, replaceObj: { [key: string]: string }): string {
        let transformedValue = value;

        Object.entries(replaceObj).forEach(([k, v]) => (transformedValue = value.replace(`{{${k}}}`, v)));

        return transformedValue;
    }
}
